export const typeOfZeroFilterResults = 'zeroFilterResultsDialogType';
export const headerString ='No results found';
export const zeroResultMEssage = 'Your selected filter criteria were too restrictive. Please reconsider and try again.';
